import type { SideRelatedContent } from '@ps/web-martech-cms-types';
import React from 'react';

import { CMSHTML, CMSImage, CMSLink } from '@swf/cms';

import styles from './CMSSideRelatedContent.scss';

const CMSSideRelatedContent: React.FC<SideRelatedContent> = ({ heading, content, thumb, link }) =>
  heading || content || thumb || link ? (
    <div>
      {heading && <h3>{heading}</h3>}
      {(thumb.asset || content || link.url) && (
        <div className={styles.wrapper}>
          <CMSImage {...{ ...thumb, className: styles.image }} />
          <CMSHTML content={content} />
          {link.url && <CMSLink {...{ ...link, className: styles.link }} />}
        </div>
      )}
    </div>
  ) : null;
export default CMSSideRelatedContent;
